import { useEffect } from "react";
import { applySeoMeta, setJsonLd, clearJsonLd, type SeoData } from "@/lib/seo";

export function useSeo(data: SeoData, jsonLd?: object | object[]): void {
  useEffect(() => {
    applySeoMeta(data);
    if (jsonLd) {
      setJsonLd(jsonLd);
    } else {
      clearJsonLd();
    }
  });
}